import React from 'react';

import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {GRAY_DARK} from 'ui-library/Colors';
import {UnitsQuery, UnitsQueryVariables} from 'units/__generated/UnitsQuery';
import {UNITS_QUERY} from 'units/UnitsConstants';

interface Props {
  value: string;
  unitApiIdentifier: string;
}
export default function UnitAwareNumberTagValueViewer(props: Props): JSX.Element {
  const response = useSkippableBenchlingQuery<UnitsQuery, UnitsQueryVariables>(UNITS_QUERY, {
    variables: {ids: [props.unitApiIdentifier]},
  });

  let unitSymbol;
  if (response && response.type === QueryResultType.SUCCESS) {
    unitSymbol = <span style={{color: GRAY_DARK}}> {response.data.units[0].symbol}</span>;
  }

  if (props.value.length === 0 && unitSymbol) {
    return <div style={{textAlign: 'right'}}>{unitSymbol}</div>;
  }

  return (
    <div>
      <span>{props.value}</span>
      {unitSymbol}
    </div>
  );
}
